module.exports = __webpack_public_path__ + "img/home-bottom.0b97ca28.png";